import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { Router } from '@angular/router';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit {
  email: String = '';
  password: String = '';
  invalid: boolean = false;
  logo = '';
  cloading = true;
  defaultHomePage = '';
  text = '';
  passField = true;
  constructor(
    private apiService: ApiService,
    private router: Router,
    public translations: TranslationService
  ) { }

  ngOnInit() {
    this.apiService.getClient().subscribe((res: any) => {
      this.cloading = false;
      this.defaultHomePage = res.data.defaultHomePage;
      if (res.data.loginImage) {
        this.logo = res.data.loginImage;
      }
      if (res.data.loginQuote) {
        this.text = res.data.loginQuote;
      }
    });
  }

  togglePassword() {
    this.passField = !this.passField;
  }

  getBackgroundUrl() {
    if (this.cloading) {
      return '';
    }
    if (this.logo) {
      return this.logo;
    } else {
      return 'https://www.tompetty.com/sites/g/files/g2000007521/f/Sample-image10-highres.jpg';
    }
  }

  login() {
    this.invalid = false;
    this.apiService.login({ email: this.email, password: this.password }).subscribe((res: any) => {
      localStorage.setItem('lunge_front', res.data);
      this.router.navigate([`/${this.defaultHomePage ? this.defaultHomePage : 'dashboard'}`]);
    }, err => {
      this.invalid = true;
    });
  }

}
